//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {
    return {

      isOpen: false
    }
  },

  props: {

    value: {
      type: String,
      default: ""
    },

    name: {
      type: String,
      default: ""
    },

    icon: {
      type: String,
      default: ""
    },

    label: {
      type: String,
      default: ""
    },

    options: {
      type: Array,
      default: () => {
        return []
      }
    },

    disable: {
      type: Boolean,
      default: false
    },

    error: {
      type: Boolean,
      default: false
    }

  },

  computed: {
    selectLabel: function () {
      if (!this.value) {
        return this.label
      }

      return (this.options || []).find((t) => String(t.value) === this.value)?.label
    }
  },

  methods: {
    openDropDown: function () {
      this.isOpen = true;
    },
    closeDropDown: function () {
      this.isOpen = false;
    },

    onChange: function (value) {
      const target = {
        target: {
          name: this.name,
          value: String(value)
        }
      };

      this.$emit('change', target);

      this.closeDropDown();
    }
  }

}
